import { ReactNode } from "react";
import styled from "styled-components";

interface GeneralBtnProps {
  btnContent?: string;
  handleClick: () => void;
  icon?: ReactNode;
  btnConStyle?: string;
  btnStyle?: string;
  btnTextStyle?: string;
  disabled?: boolean;
}

const GeneralBtn = ({
  btnContent,
  handleClick,
  icon,
  btnConStyle,
  btnStyle,
  btnTextStyle,
  disabled,
}: GeneralBtnProps) => {
  return (
    <GeneralBtnWrapper className={btnConStyle}>
      <button
        onClick={handleClick}
        className={btnStyle}
        style={{ cursor: `${disabled ? "not-allowed" : "pointer"}` }}
        disabled={disabled}
      >
        {icon}
        {btnContent && <span className={btnTextStyle}>{btnContent}</span>}
      </button>
    </GeneralBtnWrapper>
  );
};

export default GeneralBtn;

const GeneralBtnWrapper = styled.div`
  /* align-self: flex-end; */

  > button {
    height: 35px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #ccc;
    padding-inline: 8px;
    border-radius: 8px;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  > button:hover {
    background-color: #414040;
    color: #fff;
  }
`;
